import { classes } from 'html-classes';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import Icon from '~/components/Icon/Icon';
import { IconButton, SIZE } from '~/components/isolated/IconButton';
import { useModal } from '~/hooks/useModal';

import styles from './Header.module.scss';

interface IModalHeaderProps {
  title?: string;
  children?: React.ReactNode;
  className?: string;
  titleClassName?: string;
  onClose: () => void;
  onBackPress?: () => void;
  isVisibleBackButton?: boolean;
}

const ModalHeader: FC<IModalHeaderProps> = ({
  onClose,
  onBackPress,
  title,
  children,
  className,
  titleClassName,
  isVisibleBackButton = false,
}) => {
  const { goBack } = useModal();
  return (
    <header className={classes([styles.header, className])}>
      <div className={styles.headerContainer}>
        {isVisibleBackButton ? (
          <IconButton
            size={SIZE.S}
            variant="outline"
            icon="close"
            onClick={onBackPress || goBack}
          />
        ) : null}

        {title && (
          <h2 className={classes([styles.title, titleClassName])}>{title}</h2>
        )}
      </div>
      {children}
      {isVisibleBackButton ? null : (
        <button className="button" onClick={onClose}>
          <Icon type="close" size={24} />
        </button>
      )}
    </header>
  );
};

export default observer(ModalHeader);
